(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getInputs(section) {
    return section.querySelectorAll('input, select, textarea');
  }

  function isRadioGroupChecked(section, name) {
    var radios = section.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].name === name && radios[i].checked) return true;
    }
    return false;
  }

  function isSatisfied(section) {
    var requiredEls = section.querySelectorAll('[required]');
    if (requiredEls.length) {
      var seenRadioGroups = {};
      for (var i = 0; i < requiredEls.length; i++) {
        var el = requiredEls[i];
        if (el.type === 'radio') {
          if (seenRadioGroups[el.name]) continue;
          seenRadioGroups[el.name] = true;
          if (!isRadioGroupChecked(section, el.name)) return false;
        } else if (el.type === 'checkbox') {
          if (!el.checked) return false;
        } else {
          if (!String(el.value || '').trim()) return false;
        }
      }
      return true;
    }
    var inputs = getInputs(section);
    for (var j = 0; j < inputs.length; j++) {
      var input = inputs[j];
      if (input.type === 'radio' || input.type === 'checkbox') {
        if (input.checked) return true;
      } else if (input.tagName === 'SELECT') {
        if (input.value) return true;
      } else {
        if (String(input.value || '').trim()) return true;
      }
    }
    return false;
  }

  function readableLabelFor(input) {
    if (!input.id) return '';
    var label = input.ownerDocument.querySelector('label[for="' + input.id + '"]');
    if (!label) return '';
    var tip = label.querySelector('.tool-tip');
    if (tip) return (tip.textContent || '').trim();
    return (label.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function readActiveValue(section) {
    var checkedRadio = section.querySelector('.variants__body input[type="radio"]:checked');
    if (checkedRadio) return readableLabelFor(checkedRadio) || checkedRadio.value;
    var select = section.querySelector('.variants__body select');
    if (select && select.value) {
      var opt = select.options[select.selectedIndex];
      return (opt && opt.textContent.trim()) || select.value;
    }
    var checkedBox = section.querySelector('.variants__body input[type="checkbox"]:checked');
    if (checkedBox) return readableLabelFor(checkedBox) || checkedBox.value || 'Oui';
    return '';
  }

  // --- Infobulles des pastilles métal : recalage au bord de la fenêtre ---------
  // Les bulles sont centrées sur leur pastille (CSS). Au repos elles sont en
  // visibility:hidden mais TOUJOURS dans le flux : une bulle qui dépasse le bord
  // droit de la fenêtre allonge la page en permanence (barre de défilement
  // horizontale), pas seulement au survol. On mesure chaque bulle et on écrit
  // dans --metal-tip-shift le décalage horizontal MINIMAL qui la ramène dans la
  // fenêtre ; le CSS s'en sert pour le translateX et recale la flèche en sens
  // inverse pour qu'elle reste sous sa pastille.
  // Borne = la fenêtre, et non .container comme sur les cartes produit
  // (assets/product-card-metals.js) : c'est elle qui crée la barre de défilement,
  // et s'y limiter garde le décalage minimal (mesuré à 1009 px de large avec
  // 6 métaux : 26 px de décalage au lieu de 41 px si on se bornait au conteneur).
  var TIP_MARGIN = 8; // px de respiration entre la bulle et le bord de la fenêtre

  function placeMetalTips(scope) {
    var tips = Array.prototype.slice.call(
      scope.querySelectorAll('.variants__options--color .tool-tip'));
    if (!tips.length) return;
    // Repartir de la position centrée : la mesure doit porter sur la géométrie
    // naturelle, et cela purge une valeur héritée d'une largeur précédente.
    tips.forEach(function (tip) { tip.style.removeProperty('--metal-tip-shift'); });
    var vw = document.documentElement.clientWidth;
    // Lectures groupées, puis écritures groupées : un seul recalcul de mise en page.
    var shifts = tips.map(function (tip) {
      var rect = tip.getBoundingClientRect();
      // Rect nul = panneau replié, pastille indisponible (.disabled masque la
      // bulle) ou largeur < 768px : rien à recaler, et la bulle ne pèse pas non
      // plus sur la largeur de la page.
      if (!rect.width) return 0;
      var over = TIP_MARGIN - rect.left;
      if (over > 0) return Math.round(over); // débord à gauche
      over = rect.right - (vw - TIP_MARGIN);
      return over > 0 ? -Math.round(over) : 0; // débord à droite
    });
    tips.forEach(function (tip, i) {
      if (shifts[i]) tip.style.setProperty('--metal-tip-shift', shifts[i] + 'px');
    });
  }

  function placeAllMetalTips() {
    document.querySelectorAll('[data-product-options]').forEach(placeMetalTips);
  }

  function setOpen(section, open) {
    var body = section.querySelector('.variants__body');
    var header = section.querySelector('.variants__header');
    if (!body || !header) return;
    if (open) {
      section.classList.add('is-open');
      body.removeAttribute('hidden');
      header.setAttribute('aria-expanded', 'true');
      // Un panneau replié est `display:none` : ses rectangles sont nuls et la
      // mesure impossible. L'ouverture est donc le seul moment où la rangée
      // devient mesurable — et elle couvre l'ouverture initiale, le clic sur
      // l'en-tête et le filet `invalid`, qui passent tous par ici.
      placeMetalTips(section);
    } else {
      section.classList.remove('is-open');
      body.setAttribute('hidden', '');
      header.setAttribute('aria-expanded', 'false');
    }
  }

  function syncHeaderValue(section) {
    var span = section.querySelector('[data-variants-value]');
    if (!span) return;
    var value = readActiveValue(section);
    span.textContent = value ? value.replace('VSSI', 'VS2/SI1') : '';
  }

  function openOnly(sections, indexToOpen) {
    sections.forEach(function (s, i) {
      setOpen(s, i === indexToOpen);
    });
  }

  function findInitialIndex(sections, root) {
    if (root.hasAttribute('data-default-closed')) return -1;
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].classList.contains('js-shopify-variant')) return i;
    }
    for (var j = 0; j < sections.length; j++) {
      if (sections[j].closest('.product-customization')) return j;
    }
    return sections.length ? 0 : -1;
  }

  // Sections toujours ouvertes (« Choisir le métal ») : hors accordéon. On garde
  // seulement la valeur de l'en-tête à jour et le recalage des infobulles.
  function initStatic(section) {
    var body = section.querySelector('.variants__body');
    if (body) body.removeAttribute('hidden');
    section.classList.add('is-open');
    placeMetalTips(section);
    section.addEventListener('change', function () { syncHeaderValue(section); });
  }

  function init(root) {
    var all = Array.prototype.slice.call(root.querySelectorAll('.variants-wrapper'));
    all.forEach(function (s) {
      if (s.classList.contains('variants-wrapper--static')) initStatic(s);
    });
    var sections = all.filter(function (s) {
      return !s.classList.contains('variants-wrapper--static');
    });
    if (!sections.length) return;

    sections.forEach(function (section, index) {
      var header = section.querySelector('.variants__header');
      var body = section.querySelector('.variants__body');
      if (!header || !body) return;

      header.addEventListener('click', function () {
        var willOpen = !section.classList.contains('is-open');
        if (willOpen) openOnly(sections, index);
        else setOpen(section, false);
      });

      function advanceIfSatisfied() {
        syncHeaderValue(section);
        if (!isSatisfied(section)) return;
        // Declinaison radios trigger a full page reload via inline onchange,
        // so the advance below is harmless but never observed for that section.
        if (index + 1 < sections.length) openOnly(sections, index + 1);
        else openOnly(sections, -1);
      }

      section.addEventListener('change', advanceIfSatisfied);

      // `change` only fires on actual state transitions, so re-clicking an
      // already-selected radio would otherwise be a no-op. Listen for clicks
      // on radios/checkboxes (and their labels) so the gesture still advances.
      section.addEventListener('click', function (e) {
        var target = e.target;
        var input = null;
        if (target.tagName === 'INPUT') {
          input = target;
        } else {
          var label = target.closest && target.closest('label');
          if (label) {
            input = label.control
              || (label.htmlFor && label.ownerDocument.getElementById(label.htmlFor));
          }
        }
        if (!input) return;
        if (input.type !== 'radio' && input.type !== 'checkbox') return;
        // Defer the satisfaction check to the next task. We need to read
        // the section's `[required]` state *after* the input's pre-click
        // activation, its `change` event, and any sibling `change`
        // listeners (notably the inline engraving toggle in
        // snippets/product-customization.liquid that adds `[required]`
        // to the text/verification fields when "Oui" is picked) have all
        // run — otherwise a state-changing click on "Oui" would observe
        // the pre-mutation state (gravure-non still checked, no
        // `[required]` yet), report the section as satisfied, and close
        // the panel before its now-required dependents could be filled.
        //
        // A microtask (queueMicrotask / Promise.resolve().then) is *not*
        // sufficient: per the HTML spec, on a real user click the event
        // loop performs a microtask checkpoint between successive
        // listener invocations (whenever the JS execution context stack
        // empties). That puts our microtask BEFORE the input's
        // synchronously-dispatched click + change events, i.e. while the
        // section still holds the pre-click DOM state — exactly the
        // race we are trying to avoid.
        //
        // A macrotask (setTimeout(…, 0)) yields a full task boundary.
        // The entire user-gesture dispatch chain (label click →
        // synthetic input click → input change → all bubble-phase
        // listeners) is one task; the deferred callback runs in the
        // *next* task, by which time the DOM is final.
        //
        // Idempotent with the section's `change` listener (which has
        // already advanced for state-changing clicks by the time this
        // fires); for re-clicks no `change` fires and this is the only
        // path that drives the advance.
        setTimeout(advanceIfSatisfied, 0);
      });

    });

    // Filet de sécurité « Ajouter au panier » : un contrôle `[required]` situé dans une
    // section repliée est `display:none` (cf. `.variants__body[hidden]`), donc NON focusable.
    // À la soumission, la validation native du navigateur échoue dessus et annule l'envoi
    // SANS afficher de bulle (le bouton paraît inerte). Les événements `invalid` ne bouillonnent
    // pas mais se propagent en phase de capture : on les intercepte sur `root` et on rouvre la
    // section fautive AVANT l'étape de focus du navigateur (toutes les `invalid` sont émises,
    // puis le focus est posé), de sorte que le contrôle redevient focusable à temps et que la
    // bulle de validation native s'affiche. Couvre tous les `[required]` (taille/longueur,
    // gravure, bijou-texte) sans énumération. Idempotent avec l'accordéon.
    root.addEventListener('invalid', function (e) {
      var section = e.target.closest && e.target.closest('.variants-wrapper');
      if (section && !section.classList.contains('variants-wrapper--static')) setOpen(section, true);
    }, true);

    // `wpbingo.js` bascule la classe `disabled` — donc l'affichage des infobulles —
    // en réponse au même `change`, et il le fait pour les options 2 et 3 : or
    // « Choisir le métal » est la 3e option sur plusieurs produits. On mesure à la
    // tâche suivante, une fois ses écritures faites (même raison que le setTimeout
    // commenté plus haut). Posé sur `root` : un choix fait dans une AUTRE section
    // (pureté, couleur) est ce qui rend des métaux (in)disponibles.
    root.addEventListener('change', function () {
      setTimeout(function () { placeMetalTips(root); }, 0);
    });

    openOnly(sections, findInitialIndex(sections, root));
  }

  ready(function () {
    document.querySelectorAll('[data-product-options]').forEach(init);

    // Le recalage dépend de la largeur de la fenêtre : on rejoue au
    // redimensionnement, au plus une fois par frame (couvre aussi le zoom).
    var pending = false;
    window.addEventListener('resize', function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        placeAllMetalTips();
      });
    });

    // La largeur d'une bulle dépend du rendu du texte : une police chargée après
    // le premier affichage la change, donc la mesure initiale peut être périmée.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(placeAllMetalTips);
    }
  });
})();
